import { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'
import { MovieState } from '../movieState'
//Animation
import { motion } from 'framer-motion'
import { pageAnimation } from '../animation'

// const MovieDetail = ( {history} ) => {
const MovieDetail = () => {
    const history = useHistory()
    const url = history.location.pathname
    const [movies] = useState(MovieState)
    const [movie, setMovie] = useState(null)
    
    useEffect(() => {
        const currentMovie = movies.find((stateMovie) => stateMovie.url === url)
        setMovie(currentMovie)
        // if (!currentMovie) {
        //     history.replace("/404")
        // }
    }, [movies, url])

    return (
        <>
        {movie && (
            <Details 
                variants={pageAnimation} 
                initial='hidden' 
                animate='show'
                exit='exit'
            >
                <HeadLine>
                    <h2>{movie.title}</h2>
                    <img src={movie.mainImg} alt={movie.title}/>
                </HeadLine>
                <Awards>
                    {movie.awards.map((award) => (
                        <Award
                            title={award.title}
                            description={award.description}
                            key={award.title}
                        />
                    ))}
                </Awards>
                <ImageDisplay>
                    <img src={movie.secondaryImg} alt="movie" />
                </ImageDisplay>
            </Details>
        )}
        </>
    )
}

const Details = styled(motion.div)`
    color: white;
`
const HeadLine = styled.div`
    min-height: 90vh;
    margin-top: 10vh;
    position: relative;
    text-align: center;
    h2 {
        margin-bottom: 3rem;
        /* position: absolute;
        top: 10%;
        left: 50%;
        transform: translate(-50%, -10%); */
    }
    img {
        width: 90%;
        height: 90%;
        object-fit: contain;
    }
    @media (max-width: 1300px) {
        min-height: 20vh;
        margin: 2rem 1rem;
    }    
`

const Awards = styled.div`
    min-height: 80vh;
    display: flex;
    margin: 5rem 10rem;
    align-items: center;
    justify-content: space-around;
    @media (max-width: 1300px) {
        min-height: 20vh;
        display: block;
        margin: 2rem 1rem;
    }
`

const AwardStyle = styled.div`
    padding: 5rem;
    h3 {
        font-size: 2rem;
    }
    .line {
        width: 100%;
        background: #23d997;
        height: 0.5rem;
        margin: 1rem 0rem;
    }
    p {
        padding: 2rem 0rem;
    }
    @media (max-width: 1300px) {
        padding: 2rem 1.5rem;
    }    
`
const ImageDisplay = styled.div`
    min-height: 50vh;
    text-align: center;
    margin-bottom: 5rem;
    img {
        width: 90%;
        height: 90%;
        object-fit: contain;
    }
`

//Award Component
const Award = ({ title, description }) => {
    return (
        <AwardStyle>
            <h3>{title}</h3>
            <div className="line"></div>
            <p>{description}</p>
        </AwardStyle>
    )
}

export default MovieDetail